import { OverrideFunc } from '../../../../model/Override'

export const MuiStack: OverrideFunc<'MuiStack'> = () => ({
  defaultProps: {
    direction: 'row',
  },
})
